import React, { FC } from "react";
import { Link } from "react-router-dom";

import { LABELS } from "../../../constants/teaching_materials";
import { ReactComponent as IconTextbook } from "../../../assets/images/Textbook/icon_textbook.svg";
import { ReactComponent as IconArrow } from "../../../assets/images/Textbook/icon_arrow.svg";
import thumbBasic from "../../../assets/images/Textbook/thumb_basic.webp";
import thumbActiveLearning from "../../../assets/images/Textbook/thumb_active-learning.webp";
import ExchangeYear from "../../../organisms/teacher/ExchangeYear";
import styles from "../Select.module.scss";

export type Props = {
  basicPath: string;
  activeLearningPath: string;
  has_base: boolean;
  isShowExchangeYearLink?: boolean;
};

const Textbook: FC<Props> = ({
  basicPath,
  activeLearningPath,
  has_base,
  isShowExchangeYearLink,
}) => {
  const coreBasicLabel = `${has_base ? `${LABELS.base}/` : ""}${
    LABELS.coreBasic
  }`;

  return (
    <div className={styles.body}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.inner}>
            {isShowExchangeYearLink && <ExchangeYear />}
            <p className={styles.title}>
              <IconTextbook />
              教材を選んでください
            </p>
            <div className={styles.content}>
              <div className={styles.textbooks}>
                <div className={styles.textbook}>
                  <Link className={styles.link} to={basicPath}>
                    <img
                      className={styles.thumb}
                      src={thumbBasic}
                      alt={coreBasicLabel}
                    />
                    <div className={styles.label}>
                      <span className={styles.name}>{coreBasicLabel}</span>
                      <IconArrow />
                    </div>
                  </Link>
                </div>
                <div className={styles.textbook}>
                  <Link className={styles.link} to={activeLearningPath}>
                    <img
                      className={styles.thumb}
                      src={thumbActiveLearning}
                      alt={LABELS.coreActiveLearning}
                    />
                    <div className={styles.label}>
                      <span className={styles.name}>
                        {LABELS.coreActiveLearning}
                      </span>
                      <IconArrow />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Textbook;
